import React, { useState } from 'react';
import { Container, Row, Col, Form } from 'react-bootstrap';
import Popup from 'reactjs-popup';
import Button from '../Parts/Button';
import { CouponReasonTypes } from '../powershadesApiTypes';

interface DiscountReasonModalProps {
	open: boolean;
	onClose?: () => void;
	onCancel?: () => void;
	onSubmit?: (reason: string, couponReasonTypeId: number | null) => void;
	quoteType?: string;
	defaultReason?: string;
	couponReasonTypes?: CouponReasonTypes[];
	defaultReasonTypeId?: number | null;
}

const DiscountReasonModal: React.FC<DiscountReasonModalProps> = ({
	open,
	onClose,
	onCancel,
	onSubmit,
	quoteType = 'green',
	defaultReason = '',
	couponReasonTypes = [],
	defaultReasonTypeId = null,
}) => {
	const [reason, setReason] = useState(defaultReason);
	const [reasonTypeId, setReasonTypeId] = useState<number | null>(defaultReasonTypeId);

	const handleCancel = () => {
		setReason(defaultReason);
		setReasonTypeId(defaultReasonTypeId);
		onCancel && onCancel();
		onClose && onClose();
	};

	const isRMA = defaultReason == 'RMA';

	const handleSubmit = () => {
		const hasReasonType = couponReasonTypes.length === 0 || reasonTypeId !== null;
		if (reason.trim().length > 0 && (hasReasonType || isRMA)) {
			onSubmit && onSubmit(reason.trim(), reasonTypeId);
			setReason('');
			setReasonTypeId(null);
		}
	};

	const hasReasonType = couponReasonTypes.length === 0 || reasonTypeId !== null;
	const isSubmitDisabled = reason.trim().length === 0 || (!hasReasonType && !isRMA);

	return (
		<Popup
			open={open}
			onClose={handleCancel}
			className="mobile-modal"
			closeOnDocumentClick={false}
		>
			<Container className="local-bootstrap">
				<Row>
					<Col>
						<h2 className={`text-${quoteType}`}>Discount Reason</h2>
					</Col>
				</Row>
				{couponReasonTypes.length > 0 && (
					<Row className="mb-2">
						<Col>
							<Form.Label className="w-100">
								Reason Type:
								<Form.Select
									value={reasonTypeId ?? ''}
									onChange={(e) => setReasonTypeId(e.target.value ? Number(e.target.value) : null)}
									className="mt-1"
									disabled={isRMA}
								>
									<option value="">- Select Reason Type -</option>
									{couponReasonTypes.map((rt) => (
										<option key={rt.id} value={rt.id}>
											{rt.name}
										</option>
									))}
								</Form.Select>
							</Form.Label>
						</Col>
					</Row>
				)}
				<Row>
					<Col>
						<Form.Label className="w-100">
							Please provide a reason for the discount:
							<Form.Control
								as="textarea"
								rows={4}
								value={reason}
								onChange={(e) => setReason(e.target.value)}
								className="mt-2"
							/>
						</Form.Label>
					</Col>
				</Row>
				<Row className="mt-3">
					<Col className="text-start">
						<Button color="gray" onClick={handleCancel}>
							Cancel
						</Button>
					</Col>
					<Col className="text-end">
						<Button
							color={quoteType}
							disabled={isSubmitDisabled}
							onClick={handleSubmit}
						>
							Submit
						</Button>
					</Col>
				</Row>
			</Container>
		</Popup>
	);
};

export default DiscountReasonModal;
